import React from 'react';
import * as _ from 'ramda';

// export default class Suspense extends React.Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             loading: false,
//             initialLoad: true,
//             request: null,
//             responses: null
//         };
//     }
//
//     runQueries = (queries: [Function]) => {
//         let allRequestPromises = queries.map(ac => {
//             ac();
//         });
//         let requestKeys = _.keys(this.props.apiCalls);
//         this.setState({
//             loading: true,
//             responses: null,
//             initialLoad: false,
//             request: Promise.all(allRequestPromises).then(responses => {
//                 let obj = _.zipObj(requestKeys, responses);
//                 this.setState({
//                     responses: obj,
//                     loading: false,
//                     requests: null
//                 });
//             })
//         });
//     };
//
//     componentDidMount() {
//         let queries = _.values(this.props.apiCalls).map(ac => {
//             return ac.fn || ac;
//         });
//         this.runQueries(queries);
//     }
//
//     componentDidUpdate() {
//         let queries = _.values(this.props.apiCalls)
//             .filter(ac => {
//                 return ac.onUpdate;
//             })
//             .map(ac => ac.fn);
//         this.runQueries(queries);
//     }
//
//     render() {
//         if (this.state.responses) {
//             return React.Children.map(this.props.children, (child, i) => {
//                 return React.cloneElement(child, { ...this.state.responses, update: this.update });
//             });
//         }
//         return null;
//     }
// }

export default class Suspense extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            initialLoad: true,
            request: null,
            responses: null
        };
    }

    componentDidMount() {
        let allRequestPromises = _.values(this.props.apiCalls).map(ac => ac());
        let requestKeys = _.keys(this.props.apiCalls);
        this.setState({
            loading: true,
            responses: null,
            initialLoad: false,
            request: Promise.all(allRequestPromises).then(responses => {
                let obj = _.zipObj(requestKeys, responses);
                this.setState({
                    responses: obj,
                    loading: false,
                    requests: null
                });
            })
        });
    }

    update = (field: string, ...args) => {
        let apiCall = this.props.apiCalls[field];
        let requestPromise = apiCall(...args);

        let allRequestPromises = [requestPromise];
        let requestKeys = [field];
        this.setState({
            loading: true,
            responses: this.state.responses,
            request: Promise.all(allRequestPromises).then(responses => {
                let obj = _.zipObj(requestKeys, responses);
                this.setState({
                    responses: { ...this.state.responses, ...obj },
                    loading: false,
                    requests: null
                });
            })
        });
    };

    render() {
        if (this.state.responses) {
            return React.Children.map(this.props.children, (child, i) => {
                return React.cloneElement(child, { ...this.state.responses, update: this.update });
            });
        }
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/customModules/Common/components/Suspense-component.js